import React, { useCallback } from "react";

import { faEllipsisH } from "@fortawesome/pro-solid-svg-icons/faEllipsisH";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "antd/es/dropdown";
import Menu from "antd/es/menu";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { Button } from "@mapmycustomers/ui";

import Path from "@app/enum/Path";
import SettingPath from "@app/enum/settings/SettingPath";

import styles from "./RelationshipsMenu.module.scss";

interface Props {}

const RelationshipsMenu: React.FC<Props> = () => {
  const intl = useIntl();

  const [visible, show, hide] = useBoolean(false);

  const handleShowCustomize = useCallback(() => {
    window.open(`${Path.SETTINGS}/${SettingPath.PINNED_FIELDS}`, "_blank");
    hide();
  }, [hide]);

  const handleOpenChange = useCallback(
    (open) => {
      if (open) {
        show();
      } else {
        hide();
      }
    },
    [hide, show]
  );

  return (
    <>
      <Dropdown
        onOpenChange={handleOpenChange}
        open={visible}
        overlay={
          visible ? (
            <Menu
              className={styles.menu}
              expandIcon={<span />}
              mode="vertical"
              triggerSubMenuAction="click"
            >
              <Menu.Item key="customize" onClick={handleShowCustomize}>
                {intl.formatMessage({
                  id: "recordPane.relationship.customizeRows",
                  defaultMessage: "Customize Rows",
                  description: "View Menu - Customize Rows menu item title",
                })}
              </Menu.Item>
            </Menu>
          ) : (
            <span />
          )
        }
        placement="bottomRight"
        trigger={["click"]}
      >
        <Tooltip
          title={intl.formatMessage({
            id: "map.recordsList.viewMenu.tooltip",
            defaultMessage: "View Menu",
            description: "View Menu toolbar button text",
          })}
        >
          <Button className={styles.button}>
            <FontAwesomeIcon icon={faEllipsisH} />
          </Button>
        </Tooltip>
      </Dropdown>
    </>
  );
};

export default RelationshipsMenu;
